import { render, staticRenderFns } from "./art_ques.vue?vue&type=template&id=25d84714&scoped=true&"
import script from "./art_ques.vue?vue&type=script&lang=js&"
export * from "./art_ques.vue?vue&type=script&lang=js&"
import style0 from "./art_ques.vue?vue&type=style&index=0&id=25d84714&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d84714",
  null
  
)

export default component.exports